module.exports = __webpack_public_path__ + "assets/img/smartTV-icon3.094ed732.png";